import React from 'react';
import Input from '../Input';
import FieldError from '../FieldError';
import FieldWrapper from '../FieldWrapper';
import Label from '../Label';

// eslint-disable-next-line
const FormikInputField = ({ field, type, form, label, hidden, ...other }) => {
  return (
    <FieldWrapper hidden={hidden}>
      {label && <Label>{label}</Label>}
      <Input
        type={type}
        hasError={(field.name in form.touched) && (field.name in form.errors)}
        {...field}
        {...other}
      />
      {form.errors[field.name] && form.touched[field.name]
        && <FieldError>{form.errors[field.name]}</FieldError>}
    </FieldWrapper>

  );
};

export default FormikInputField;
